
import SocialMediaType from '@/enums/SocialMediaType';

export default {
  i18nComponentKey: 'ReviewsShow.components.EmbeddedSocialMediaReviewPc',
  name: 'EmbeddedSocialMediaReviewPc',
  props: {
    review: { type: Object, required: true }
  },
  computed: {
    SocialMediaType: () => SocialMediaType
  }
};
